import React from "react";
import type { AccountData } from "../../../hooks/useMyAccountData";

interface EditAdminModalProps {
  editAccountData: AccountData;
  setEditAccountData: (data: AccountData) => void;
  onClose: () => void;
  handleEditAdmin: () => void;
}

const EditAdminModal: React.FC<EditAdminModalProps> = ({
  editAccountData,
  setEditAccountData,
  onClose,
  handleEditAdmin,
}) => (
  <div
    className="modal-overlay"
    data-testid="edit-admin-modal-overlay"
    onClick={onClose}
  >
    <div
      className="modal-content"
      data-testid="edit-admin-modal-content"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-header" data-testid="edit-admin-modal-header">
        <h3>Edit Admin Contact</h3>
        <button
          className="close-button"
          data-testid="edit-admin-modal-close-button"
          onClick={onClose}
        >
          ✕
        </button>
      </div>
      <div className="modal-body" data-testid="edit-admin-modal-body">
        <div className="form-group">
          <label>Name</label>
          <input
            type="text"
            data-testid="edit-admin-name-input"
            value={editAccountData.adminName}
            onChange={(e) =>
              setEditAccountData({
                ...editAccountData,
                adminName: e.target.value,
              })
            }
          />
        </div>
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            data-testid="edit-admin-email-input"
            value={editAccountData.adminEmail}
            onChange={(e) =>
              setEditAccountData({
                ...editAccountData,
                adminEmail: e.target.value,
              })
            }
          />
        </div>
        <div className="form-group">
          <label>Phone</label>
          <input
            type="tel"
            data-testid="edit-admin-phone-input"
            value={editAccountData.adminPhone}
            onChange={(e) =>
              setEditAccountData({
                ...editAccountData,
                adminPhone: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="modal-footer" data-testid="edit-admin-modal-footer">
        <button
          className="action-button secondary"
          data-testid="edit-admin-modal-cancel-button"
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          className="action-button primary"
          data-testid="edit-admin-modal-save-button"
          onClick={handleEditAdmin}
        >
          Save Changes
        </button>
      </div>
    </div>
  </div>
);

export default EditAdminModal;
